import { useState } from 'react';

export const useEnableUserId = () => {
  const [userIdEnabled, setUserIdEnabled] = useState<boolean>(false);

  const handleUserIdToggleChange = () => {
    setUserIdEnabled(!userIdEnabled);
  };

  return {
    userIdEnabled,
    handleUserIdToggleChange,
  };
};
